import React from "react";
import { NavLink, useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();

  const footerLinks = [
    {
      title: "Home",
      link: "/",
      icon: <img id="reels2" alt='home' src='/modern-home.svg' className={location.pathname === "/" ? "w-[24px] h-[24px] invert" : "w-[24px] h-[24px] invert brightness-[0.8]"} />
    },
    {
      title: "Mine",
      link: "/earn",
      icon: <img alt='mine' src='/modern-mine.svg' className={location.pathname === "/earn" ? "w-[24px] h-[24px] invert" : "w-[24px] h-[24px] invert brightness-[0.8]"} />
    },
    {
      title: "Spin",
      link: "/spin",
      icon: <img alt='spin' src='/modern-spin.svg' className={location.pathname === "/spin" ? "w-[24px] h-[24px] invert" : "w-[24px] h-[24px] invert brightness-[0.8]"} />
    },
    // Temporarily hidden Friends section
    /*{
      title: "Friends",
      link: "/ref",
      icon: <img alt='friends' src='/modern-friends.svg' className={location.pathname === "/ref" ? "w-[24px] h-[24px] invert" : "w-[24px] h-[24px] invert brightness-[0.8]"}/>
    },*/
    {
      title: "Leaders",
      link: "/leaderboard",
      icon: <img alt='leaders' src='/modern-leaders.svg' className={location.pathname === "/leaderboard" ? "w-[24px] h-[24px] invert" : "w-[24px] h-[24px] invert brightness-[0.8]"} />
    },
  ];

  return (
    <div className="w-full flex z-30 relative items-center justify-center space-x-3">

      {footerLinks.map((footer, index) => (
      <NavLink 
      key={index}
      to={footer.link}
      className={({ isActive }) => {
        return `

${
isActive
  ? "w-[20%] flex flex-col rounded-[10px] items-center justify-center text-primary text-[13px]"
  : "w-[20%] flex flex-col space-y-[2px] rounded-[10px] items-center justify-center text-[13px]"
}
  `;
      }}
    >
              <span id="reels" className={location.pathname === `${footer.link}` ? 
  `w-[60px] h-[34px] bg-btn mb-[6px] flex flex-col rounded-[24px] items-center justify-center text-[13px]`
  : "w-[60px] h-[34px] flex flex-col space-y-[2px] rounded-[10px] items-center justify-center text-primary text-[13px]"}>
                {footer.icon}
              </span>
        <span className="font-medium">{footer.title}</span>
        </NavLink>
      ))}


    </div>
  );
};

export default Footer;
